import { MedicationPhrase, MedicationPhraseLine } from "./medication/medication-phrase";
import { SmartPhraseTrigger } from "./trigger";

export { SmartPhraseProvider, useSmartPhrasePatient } from "./context";

/** Every phrase node. Mounted wherever a note is shown, so a saved phrase always reads back as one. */
export const PHRASE_NODES = [MedicationPhrase, MedicationPhraseLine];

/** The nodes plus the "." trigger, for an editor a clinician writes in. */
export const SMART_PHRASE_EXTENSIONS = [...PHRASE_NODES, SmartPhraseTrigger];
